<template>
    <div class="bookServiceMOT">
        <div class="bookServiceMOT__tabs">
            <button type="button"
                    class="bookServiceMOT__tab"
                    :class="{ 'bookServiceMOT__tab--active': type.value === vehicleType }"
                    v-for="type in vehicleTypes"
                    :key="type.value"
                    @click="onVehicleType(type.value)"
            >
                <Component :is="type.logo" :is-white="type.value === vehicleType" v-if="type.logo" />
                <span :class="{ 'sr-only': type.logo }">{{ type.label }}</span>
            </button>
        </div>

        <div class="bookServiceMOT__wrap">
            <div class="bookServiceMOT__body" v-if="vehicleType === 'carz'">
                <form class="sfServiceBookingForm__form" @submit.prevent="onSubmit">
                    <div class="sfServiceBookingForm__row">
                        <label for="vrm" class="sr-only">Registration number</label>
                        <div class="sfServiceBookingForm__inputWrap">
                            <input type="text"
                                   name="reg_num"
                                   id="vrm"
                                   v-model="vrm"
                                   placeholder="Enter vehicle reg"
                                   class="sfServiceBookingForm__input"
                                   @input="onInput"
                            />
                        </div>
                    </div>

                    <div class="sfServiceBookingForm__row">
                        <label for="mileage" class="sr-only">Mileage</label>
                        <div class="sfServiceBookingForm__inputWrap">
                            <input type="number"
                                   name="mileage"
                                   id="mileage"
                                   v-model.number="mileage"
                                   placeholder="Enter mileage"
                                   class="sfServiceBookingForm__input"
                                   @input="onInput"
                            />
                        </div>
                    </div>

                    <div class="sfServiceBookingForm__row">
                        <label for="location" class="sr-only">Location</label>
                        <div class="sfServiceBookingForm__selectWrap" :class="{ 'sfServiceBookingForm__selectWrap--noArrow': carzLocations.length === 1 }">
                            <select name="location"
                                    id="location"
                                    class="sfServiceBookingForm__select"
                                    v-model="location"
                                    @change="onInput"
                            >
                                <option value="" v-if="carzLocations.length > 1">Location</option>
                                <option :value="location.id" v-for="location in carzLocations">
                                    {{ location.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <button type="submit" class="sfServiceBookingForm__button" :disabled="isFormDisabled">
                        Book now
                    </button>
                </form>

                <div class="sfServiceBookingForm__iframeContainer"
                     :class="{ 'sfServiceBookingForm__iframeContainer--flyout': isFlyout && valid && isFlyoutOpen }"
                     v-if="(isFlyout && isFlyoutOpen && valid) || (!isFlyout && valid)"
                >
                    <button type="button"
                            class="sfServiceBookingForm__close"
                            v-if="isFlyout && isFlyoutOpen"
                            @click="onFlyoutClose"
                    >
                        <span class="sfServiceBookingForm__close__lines"></span>
                        <span class="sr-only">Close</span>

                    </button>
                    <iframe :src="iframeUrl" width="100%" height="600"></iframe>
                </div>
            </div>

            <div class="bookServiceMOT__body" v-else>
                <div class="bookServiceMOT__content">
                    <h2 class="bookServiceMOT__contentTitle">{{ selectedVehicleType.label }}</h2>
                    <div class="bookServiceMOT__addresses" v-if="selectedVehicleType.addresses.length">
                        <div class="bookServiceMOT__address" v-for="address in selectedVehicleType.addresses">
                            <div v-html="address.address" />
                            <a :href="`tel:${address.phone.replace(' ', '')}`" class="bookServiceMOT__button" v-if="address.phone">Call us on {{ address.phone }}</a>
                            <a :href="address.serviceLink" class="bookServiceMOT__button" target="_blank" v-if="address.serviceLink">Book Service Now</a>
                        </div>
                    </div>
                    <div class="bookServiceMOT__additionalContent" v-if="selectedVehicleType.content !== ''" v-html="selectedVehicleType.content" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BMWLogo from '../../global/components/icons/brands/BMWLogo.vue'
import CarzLogo from '../../global/components/icons/brands/CarzLogo.vue'
import LandRoverLogo from '../../global/components/icons/brands/LandRoverLogo.vue'
import MiniLogo from '../../global/components/icons/brands/MiniLogo.vue'
import JaguarLogo from '../../global/components/icons/brands/JaguarLogo.vue'

export default {
    props: {
        locations: {
            type: Array,
            default: () => []
        },
        isTestMode: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BMWLogo,
        CarzLogo,
        LandRoverLogo,
        MiniLogo,
        JaguarLogo,
    },
    data() {
        return {
            vehicleType: 'carz',
            vrm: '',
            mileage: '',
            location: '',
            formErrors: {},
            valid: false,
            windowWidth: 0,
            isFlyoutOpen: false,

        }
    },
    created() {
        this.getInitialTab()
        this.setLocationToCarz(this.vehicleType)
        this.setWindowWidth()
        window.addEventListener('resize', this.setWindowWidth);
    },
    destroyed() {
        window.removeEventListener('resize', this.setWindowWidth)
    },
    methods: {
        onVehicleType(value) {
            this.vehicleType = value
            this.setLocationToCarz(value)
        },
        setWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        onSubmit() {
            this.valid = true

            if (this.isFlyout) {
                this.isFlyoutOpen = true
            }
        },
        onInput() {
            this.valid = false
        },
        onFlyoutClose() {
            this.isFlyoutOpen = false
            this.valid = false
        },
        getInitialTab() {
            const urlParams = new URLSearchParams(window.location.search)
            const serviceTab = urlParams.get('service-tab')

            if (!serviceTab) {
                return
            }

            const found = this.vehicleTypes.find((t) => t.value === serviceTab)

            if (!found) {
                return
            }

            this.vehicleType = serviceTab
        },
        setLocationToCarz(type) {
            if (type !== 'carz') {
                return
            }

            this.location = this.carzLocations[0].id
        }
    },
    watch: {
        windowWidth(val) {
            if (val > 670 && this.isFlyoutOpen) {
                this.isFlyoutOpen = false
            }
        },
    },
    computed: {
        vehicleTypes() {
            return [
                {
                    label: 'CARZ',
                    value: 'carz',
                    logo: 'CarzLogo',
                    content: '<p>Our CARZ Servicing departments are temporarily closed for Retail Bookings. If you have a Servicing Plan through the CARZ Club or have had your car for under 3 months, please contact us. We apologise for any inconvenience.</p><p><a href="/contact" class="bookServiceMOT__button">Contact us</a>',
                    addresses: []
                },
                {
                    label: 'Peter Vardy BMW',
                    value: 'bmw',
                    logo: 'BMWLogo',
                    content: '',
                    addresses: [
                        { 
                            address: 'BMW Edinburgh<br/>20C Seafield Road East<br />Edinburgh, EH15 1ED<br /><a href="tel:01313229031">01313 229031</a>',
                            serviceLink: 'https://petervardybmw.bmw-retailer-service.co.uk/'
                        }
                    ]
                },
                {
                    label: 'Peter Vardy Jaguar',
                    value: 'jaguar',
                    logo: 'JaguarLogo',
                    content: '',
                    addresses: [
                        {
                            address: 'Jaguar Aberdeen<br/>Wellington Road<br />West Tullos Industrial Estate<br />Aberdeen, AB12 3LQ',
                            phone: '01224 002857'
                        }
                    ]
                },
                {
                    label: 'Peter Vardy Land Rover',
                    value: 'land-rover',
                    logo: 'LandRoverLogo',
                    content: '',
                    addresses: [
                        {
                            address: 'Land Rover Aberdeen<br />Wellington Road<br />West Tullos Industrial Estate<br />Aberdeen, AB12 3LQ',
                            phone: '01224 002858'
                        }
                    ]

                },
                {
                    label: 'Peter Vardy MINI',
                    value: 'mini',
                    logo: 'MiniLogo',
                    content: '',
                    addresses: [
                        {
                            address: 'MINI Edinburgh<br />20B Seafield Road East<br />Edinburgh, EH15 1ED<br /><a href="tel:01313229032>01313 229032</a>',
                            serviceLink: 'https://petervardymini.mini-retailer-service.co.uk/'
                        }
                    ]
                },
            ]
        },
        selectedVehicleType() {
            return this.vehicleTypes.find((v) => v.value === this.vehicleType)
        },
        carzLocations() {
            return this.locations.filter((l) => l.name.toLowerCase().includes('carz')).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        },
        isFlyout() {
            return this.windowWidth <= 670
        },
        isFormDisabled() {
            return this.vrm === '' || this.mileage === '' || this.location === ''
        },
        iframeUrl() {
            // Please note; reg_num param needs to come first as anywhere else encodes with &reg to (r) and SF doesn't parse these correctly if sent as url encoded & (%26)
            // TEST URL: 'https://keyloopmotors.devservicestorefront.co.uk/processing-request?&reg_num=OY62VSD&location=J2060J0727T&mileage=17000'

            // Show only test link until ready to go live as Keyloop have flagged testing real URL will skew sessions
            if (this.isTestMode) {
                return `https://keyloopmotors.devservicestorefront.co.uk/processing-request?reg_num=${this.vrm}&location=J2060J0727T&mileage=${this.mileage}&utm_source=${this.utmSource}&utm_medium=${this.utmMedium}&utm_campaign=${this.utmCampaign}`
            }

            return `https://petervardy.servicestorefront.co.uk/processing-request?reg_num=${this.vrm}&location=${this.location}&mileage=${this.mileage}&utm_source=${this.utmSource}&utm_medium=${this.utmMedium}&utm_campaign=${this.utmCampaign}`
        },
    }
}
</script>
